import a from "./ghl-ui.es1506.js";
import o from "./ghl-ui.es1466.js";
function n(t) {
  o(1, arguments);
  var r = a(t), e = r.getDate();
  return e;
}
export {
  n as default
};
